import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "preSaleCommPlan" }
const _hoisted_2 = { class: "tableHeader" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { style: {"margin-left":"8px"} }
const _hoisted_5 = { class: "handler" }
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-around"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", null, "删除", -1)
const _hoisted_10 = { class: "popup" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_14 = { style: {"position":"relative"} }
const _hoisted_15 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_16 = { style: {"position":"relative"} }
const _hoisted_17 = { style: {"height":"600px","overflow-y":"scroll","padding-top":"40px","position":"relative"} }
const _hoisted_18 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_19 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-right":"20px"} }, "基本信息", -1)
const _hoisted_21 = {
  key: 0,
  style: {"padding-right":"20px"}
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "history"
}
const _hoisted_24 = { style: {"display":"flex"} }
const _hoisted_25 = { class: "method-title" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "new" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 0,
  class: "historyAI"
}
const _hoisted_31 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_32 = { style: {"display":"flex"} }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "method-title" }
const _hoisted_37 = {
  key: 0,
  style: {"cursor":"pointer"}
}
const _hoisted_38 = { style: {"font-weight":"bold","color":"darkblue"} }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "method-title" }, [
  /*#__PURE__*/_createElementVNode("pre", { style: {"font-weight":"bold","color":"darkblue"} }, /*#__PURE__*/_toDisplayString('AI建议: '))
], -1)
const _hoisted_40 = { class: "method-title" }
const _hoisted_41 = { style: {"background-color":"aliceblue","padding":"10px"} }
const _hoisted_42 = {
  key: 1,
  class: "method-title"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("pre", { style: {"font-weight":"bold","color":"darkblue"} }, /*#__PURE__*/_toDisplayString('评分异常: '), -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 2,
  class: "method-title"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("pre", { style: {"font-weight":"bold","color":"darkblue"} }, /*#__PURE__*/_toDisplayString('聊天记录: '), -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 3,
  style: {"cursor":"pointer"}
}
const _hoisted_49 = { style: {"background-color":"aliceblue","padding":"10px"} }
const _hoisted_50 = {
  key: 4,
  style: {"cursor":"pointer"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("pre", { style: {"font-weight":"bold","color":"darkblue"} }, /*#__PURE__*/_toDisplayString('AI评价:'), -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 5,
  class: "method-title"
}
const _hoisted_54 = { style: {"background-color":"aliceblue","padding":"10px"} }
const _hoisted_55 = { class: "new" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 0,
  class: "history"
}
const _hoisted_58 = { style: {"display":"flex","background-color":"aliceblue"} }
const _hoisted_59 = { style: {"display":"flex","flex-direction":"column","width":"90%"} }
const _hoisted_60 = { class: "method-title" }
const _hoisted_61 = { class: "method-title" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "今日客户表现：", -1)
const _hoisted_63 = { class: "method-title" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "今日跟踪情况：", -1)
const _hoisted_65 = { class: "method-title" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "明日跟踪计划：", -1)
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "new" }
const _hoisted_70 = {
  key: 3,
  class: "recordForm"
}
const _hoisted_71 = { class: "recordFormTitle" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { style: {"color":"red","letter-spacing":"1px"} }, "*"),
  /*#__PURE__*/_createTextVNode("今日客户表现：")
], -1)
const _hoisted_73 = { class: "recordFormTitle" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { style: {"color":"red","letter-spacing":"1px"} }, "*"),
  /*#__PURE__*/_createTextVNode("今日跟踪情况：")
], -1)
const _hoisted_75 = { class: "recordFormTitle" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { style: {"color":"red","letter-spacing":"1px"} }, "*"),
  /*#__PURE__*/_createTextVNode("明日跟踪计划：")
], -1)
const _hoisted_77 = {
  key: 0,
  class: "footer"
}
const _hoisted_78 = { style: {"display":"flex","padding":"10px"} }
const _hoisted_79 = { class: "qy-user-list" }
const _hoisted_80 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_81 = { style: {"flex":"1","display":"flex","align-items":"center"} }
const _hoisted_82 = ["src"]
const _hoisted_83 = { style: {"flex":"1"} }
const _hoisted_84 = { style: {"width":"100px"} }
const _hoisted_85 = { style: {"display":"flex","align-items":"center","padding":"20px"} }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"150px"} }, "承接人", -1)
const _hoisted_87 = { class: "footer" }

import { searchFormConfig } from "./config/search.config";
import { computed, nextTick, onMounted, reactive, ref, UnwrapRef, watch } from "vue";
import "dayjs/locale/zh-cn";
import dayjs from "dayjs";
import { deletePageData, downloadData, editPageData, getListData, getPageListData } from "@/service/main/system";
import type { ContextmenuPopupArg, STablePaginationConfig } from "@surely-vue/table";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { useStore } from "@/store";
import { message } from "ant-design-vue";
import localCache from "@/utils/cache";
import { ElMessage, ElMessageBox, ElUpload } from "element-plus";
import { initEmptyParam } from "@/hooks/useInitParam";
import { Excel } from "@/utils/ExcelJs";
import { useRouter } from "vue-router";
import { EventSourcePolyfill } from "event-source-polyfill";
import { usePermission } from "@/hooks/usePermission";

interface DataItem {
  key: string
  custName: string
  attendClass: string
  corporation: string
  createTime: string
  createdBy: string

  deleted: string
  excellentStaff: string
  financingVolume: string
  followupSuggestion: string
  fund: string
  id: string
  introductionService: string
  managerAssistTracking: string
  quoteTimeAndAmount: string
  remarketing: string
  resistPoint: string
  resourceTime: string
  software: '√' | '×'
  stockPick: string
  teachers: string
  updateTime: string
  updatedBy: string
  weakness: string
}

const editUrl = '/main/preCommPlan/save'

export default /*#__PURE__*/_defineComponent({
  __name: 'PreSaleCommPlan',
  setup(__props) {

initEmptyParam()

const store = useStore()
const userInfo = store.state.login.userInfo



const canView = usePermission('preCommPlan', 'canView')

let queryParam = ref()
if (canView) {
  queryParam.value = {
    showOnJob: 0,
    isEnd: ''
  }
} else {
  if (userInfo.isManager != '1') {
    queryParam.value = {
      showOnJob: 0,
      empIds: userInfo.id,
      isEnd: ''
    }
  } else {
    queryParam.value = {
      showOnJob: 0,
      deptId: [userInfo.deptId],
      isEnd: ''
    }
  }
}
store.commit('system/changeQueyryInfo', queryParam.value)

dayjs.locale('zh-cn')

let count = 0
const preSalSearchRef = ref()

const copyValue = (val: any) => {
  console.log('copyValue', val)
  const input = document.createElement('input')
  input.setAttribute('readonly', 'readonly')
  input.setAttribute('value', val)
  document.body.appendChild(input)
  input.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
    message.info('复制成功')
  }
  document.body.removeChild(input)
}
const copyClick = (
  args: ContextmenuPopupArg<any, any>,
  type: 'cell' | 'column' | 'record'
) => {
  if (type === 'cell') {
    if (args.column.key === 'operation') return
    copyValue(args.text)
  } else if (type === 'column') {
    if (args.column.key === 'operation') return
    const { dataIndex } = args.column
    copyValue(dataSource.value.map((d) => d[dataIndex]).join('\r\n'))
  } else {
    const record = args.record
    copyValue(
      columns
        .map((c: any) => (c.dataIndex ? record[c.dataIndex] : ''))
        .filter((c) => !!c)
        .join(' ')
    )
  }
  // 3.0.1 新增
  args.hidePopup()
}

const corpNames: any = ref([])
const corpObj: any = ref({})

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpName'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.name }
  })

  corpNames.value = roleData.map((item: any) => {
    return { label: item.name, value: item.name }
  })
  corpObj.value = {}
  roleData.forEach((item: any) => {
    corpObj.value[item.name] = item.id
    corpObj.value[item.id] = item.name
  })
}
// A,B,C,D  四个级别
const levels: any = ref([
  {
    label: 'A',
    value: 'A',
    // color: '#FF4B4B',
    // color: '#50A7FF',
    color: '#FFA500',
  },
  {
    label: 'B',
    value: 'B',
    // color: '#FF9999'
    // color: '#ADD7F9',
    color: '#FFD76E',
  },
  {
    label: 'C',
    value: 'C',
    // color: '#FFCCCC'
    // color: '#E6EDF6',
    color: '#FFF4B3',
  },
  {
    label: 'D',
    value: 'D',
    // color: '#FFFFFF',
    color: '#FFFFE0',
  }
])

getCompanyList()

const acceptUserList = ref([])
const getEmp = async () => {
  let userList = await getListData('/main/employee/queryAllEmpList', {})
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id + '' }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empIds'
  )
  acceptUserList.value = userList
  userItem!.options = userOptions
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  dept!.isDisabled = store.state.login.userInfo.isManager != '1'
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const methodDialog = ref(false)
const managerMethods: any = ref([])
const getManagerMethods = async (record: any) => {
  managerMethods.value = await getListData(
    '/main/preCommPlan/queryManagerMethods/' + record.id,
    {}
  )
}
const planRecord: any = ref('')
const showMethod = (record: any) => {
  getManagerMethods(record)
  methodDialog.value = true
  planRecord.value = record
}

const txtMethod = ref('')
const showTextareaM = ref(false)
const addMethod = () => {
  mtdId.value = null
  txtMethod.value = ''
  showTextareaM.value = true
}

const cancelMethods = () => {
  txtMethod.value = ''
  showTextareaM.value = false
}

const mtdId = ref(null)
const editMethod = (mtd: any) => {
  txtMethod.value = mtd.content
  mtdId.value = mtd.id
  showTextareaM.value = true
}

const saveMethod = () => {
  let body = {
    followupSuggestion: txtMethod.value,
    recordId: mtdId.value,
    id: planRecord.value.id
  }
  editPageData('/main/preCommPlan/managerMethods/save', body).then(() => {
    getManagerMethods(planRecord.value)
    initTable(pagination.value, queryParam.value)
    showTextareaM.value = false
    txtMethod.value = ''
  })
}

const deleteMethod = (id: string) => {
  deletePageData('/main/preCommPlan/managerMethods/' + id).then(() => {
    getManagerMethods(planRecord.value)
    initTable(pagination.value, queryParam.value)
  })
}

const isCreatedToday = (createdTime: string, createdBy: string, format?: string): boolean => {
  const createdAt = dayjs(createdTime, format ? format : 'YYYY-MM-DD HH:mm:ss')
  const today = dayjs()
  console.log(today)
  return createdAt.isSame(today, 'day') && userInfo.id === createdBy
}

const alreadyHas = ref(false)

const recordDialog = ref(false)
const workerRecords = ref([])
const getWorkerRecords = async (id: string) => {
  workerRecords.value = await getListData(
    '/main/preCommPlan/queryWorkerRecords/' + id,
    {}
  )
}
const planIdR = ref('')
const showRecord = (id: string) => {
  getWorkerRecords(id)
  recordDialog.value = true
  planIdR.value = id
}

const txtRecord = ref('')
const txtRecordC = ref('')
const txtRecordP = ref('')
const r_r: any = ref(null)
const r_c: any = ref(null)
const r_p: any = ref(null)
const showTextareaR = ref(false)
const addRecord = () => {
  rtdId.value = null
  txtRecord.value = ''
  txtRecordC.value = ''
  txtRecordP.value = ''
  showTextareaR.value = true
}

const cancelRecords = () => {
  txtRecord.value = ''
  txtRecordC.value = ''
  txtRecordP.value = ''
  showTextareaR.value = false
}

const rtdId = ref(null)
const editRecord = (rtd: any) => {
  txtRecord.value = rtd.content
  txtRecordC.value = rtd.contentC
  txtRecordP.value = rtd.contentP
  rtdId.value = rtd.id
  showTextareaR.value = true
}

const saveRecord = () => {
  let body = {
    followupCondition: txtRecord.value,
    txtRecordC: txtRecordC.value,
    txtRecordP: txtRecordP.value,
    recordId: rtdId.value,
    id: planIdR.value
  }
  if (!txtRecordC.value) {
    r_c.value.focus()
    ElMessage.warning("请输入今日客户表现")
    return;
  }
  if (!txtRecord.value) {
    r_r.value.focus()
    ElMessage.warning("请输入今日跟踪情况")
    return;
  }
  if (!txtRecordP.value) {
    r_p.value.focus()
    ElMessage.warning("请输入明日跟踪计划")
    return;
  }
  editPageData('/main/preCommPlan/workerRecords/save', body).then(() => {
    getWorkerRecords(planIdR.value)
    initTable(pagination.value, queryParam.value)
    showTextareaR.value = false
  })
}

const deleteRecord = (id: string) => {
  deletePageData('/main/preCommPlan/workerRecords/' + id).then(() => {
    getWorkerRecords(planIdR.value)
    initTable(pagination.value, queryParam.value)
  })
}

// ********************************  AI  *******************************

const aiSuggestions = ref([])
const getAiSuggestions = async (id: string) => {
  aiSuggestions.value = await getListData(
    '/main/preCommPlan/queryAiSuggestions/' + id,
    {}
  )
  alreadyHas.value = false
  aiSuggestions.value.forEach((ais: any) => {
    alreadyHas.value ||= isCreatedToday(ais.createdTime, ais.createdBy)
    ais.canScore = isCreatedToday(ais.planTime, ais.createdBy, 'YYYY-MM-DD HH:mm')
  })
}
const md = ref(null)
const compiledMarkdown = (txt: string) => {
  // md.value = new MarkdownIt()
  // if(md.value) {
  //   return md.value.render(txt)
  // } else {
  //   return ''
  // }
}

const planIdAI = ref('')

const planTime = ref('')
const txtAI = ref('')
const showTextareaAI = ref(false)

const addSuggestionAI = () => {
  aiSuggestionId.value = null
  txtAI.value = ''
  showTextareaAI.value = true
  aiTxt.value = ref(null)
  planTime.value = dayjs().add(1, 'day').format('YYYY-MM-DD HH:mm')
}

const aiScore = (ais: any) => {
  editPageData('/main/preCommPlan/aiSuggestions/scoreTDAI', ais).then(() => {
    ElMessage.success('请等待5-10分钟后刷新页面查看评分')
  })
}

const clearAndCancel = () => {
  txtAI.value = ''
  showTextareaAI.value = false
  evtSource.value?.close()
  generateLoading.value = false
}

const stopAi = () => {
  txtAI.value = ''
  txtMethod.value = ''
  txtRecord.value = ''
  showTextareaR.value = false
  showTextareaM.value = false
  showTextareaAI.value = false
  evtSource.value?.close()
  generateLoading.value = false
}

const aiTxt: any = ref(null)
const evtSource = ref<InstanceType<typeof EventSourcePolyfill>>()
const generateLoading = ref(false)
const generateSuggestionAI = () => {
  txtAI.value = ''
  generateLoading.value = true
  const token = localCache.getCache('token')
  evtSource.value = new EventSourcePolyfill(process.env.VUE_APP_BASE_URL + '/main/ai/generateTDAI?planId=' + planRecord.value.id, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  evtSource.value.onmessage = (event: any) => {
    console.log('New message:', event.data);

    const resp = JSON.parse(event.data)
    // 处理接收到的消息, 如何将多次的消息合并成一个完整的消息
    if (resp.content === '[DONE]') {
      generateLoading.value = false
      evtSource.value?.close()
      return
    } else {
      txtAI.value += resp.content
    }

    nextTick(() => {
      const textarea = document.querySelector('.el-textarea__inner'); // 根据实际类名调整选择器
      if (textarea) {
        textarea.scrollTop = textarea.scrollHeight;
      }
    })
  };

  evtSource.value.onerror = (error: any) => {
    console.log('New message:', error);
    generateLoading.value = false
    evtSource.value?.close()
  };
}

const aiSuggestionId = ref(null)
const editAiSuggestion = (aiSuggestion: any) => {
  txtAI.value = aiSuggestion.content
  planTime.value = aiSuggestion.planTime
  aiSuggestionId.value = aiSuggestion.id
  showTextareaAI.value = true
}

const saveSuggestionAI = () => {
  let body = {
    content: txtAI.value,
    id: aiSuggestionId.value,
    planId: planIdAI.value,
    planTime: planTime.value
  }
  editPageData('/main/preCommPlan/aiSuggestions/save', body).then(() => {
    getAiSuggestions(planIdAI.value)
    initTable(pagination.value, queryParam.value)
    showTextareaAI.value = false
  })
}

const deleteSuggestion = (id: string) => {
  deletePageData('/main/preCommPlan/aiSuggestions/' + id).then(() => {
    getAiSuggestions(planIdAI.value)
    initTable(pagination.value, queryParam.value)
  })
}

const pagination = ref<STablePaginationConfig>({
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: (total) => `共 ${totalSize.value} 条`,
  pageSize: 10,
  current: 1
})

const onDelete = (id: string, key: string, args?: any) => {
  if ('' == id) {
    dataSource.value = dataSource.value.filter((item) => item.key !== key)
  } else {
    deletePageData('/main/preCommPlan/' + id).then(() => {
      initTable(pagination.value, queryParam.value)
    })
  }
  args?.hidePopup()
}

const handleAdd = (args?: any) => {
  const newData = {
    key: `${count}`,
    custName: '',
    corpName: '',
    attendClass: '',
    corporation: '',
    createTime: '',
    createdBy: '',
    deleted: '',
    excellentStaff: '',
    financingVolume: '',
    followupSuggestion: '',
    fund: '',
    id: '',
    introductionService: '',
    managerAssistTracking: '',
    quoteTimeAndAmount: '',
    remarketing: '',
    resistPoint: '',
    resourceTime: '',
    software: '',
    stockPick: '',
    teachers: '',
    updateTime: '',
    updatedBy: '',
    weakness: ''
  }
  count++
  dataSource.value.unshift(newData)
  dataSource.value = [].concat(dataSource.value)
  args?.hidePopup()
}

const selectCols = ref([])

let totalSize = ref(0)

const handleSearchClick = (formdata: any) => {
  console.log(formdata)
  queryParam.value = formdata
  pagination.value.current = 1 //init page
  initTable(pagination.value, formdata)
}
const handleResetClick = () => {
  initTable(pagination.value, queryParam.value)
}

const dataSource = ref<DataItem[]>([])
const importAction =
  process.env.VUE_APP_BASE_URL + '/main/preCommPlan/dataImport'

const headers = ref({})
const token = localCache.getCache('token')
headers.value = {
  Authorization: `Bearer ${token}`
}
const handleImportSuccess = (res: any) => {
  console.log(res)
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    initTable(pagination.value, queryParam.value)
    ElMessage({
      type: 'success',
      message: '导入成功'
    })
  }
}

const state = reactive<{
  selectedRowKeys: []
  loading: boolean
}>({
  selectedRowKeys: [], // Check here to configure the default column
  loading: false
})
const hasSelected = computed(() => state.selectedRowKeys.length > 0)
const selectedRowKeys = computed(() => state.selectedRowKeys)
const start = () => {
  state.loading = true
  // ajax request after empty completing
  setTimeout(() => {
    state.loading = false
    state.selectedRowKeys = []
  }, 1000)
}
const onSelectChange = (selectedRowKeys: []) => {
  console.log('selectedRowKeys changed: ', selectedRowKeys)
  state.selectedRowKeys = selectedRowKeys
}
const order = ref({
  orderBy: '',
  orderType: ''
})
const onSortChange = (page: any, filters: any, sorter: any, extra: any) => {
  console.log('params', page, filters, sorter, extra);
  order.value = {
    orderBy: sorter.field,
    orderType: sorter.order == 'ascend' ? 'ascending' : sorter.order == 'descend' ? 'descending' : ''
  }
  initTable(pagination.value, queryParam.value)
}

const handleBatchDelete = () => {
  var pageNum = pagination.value.current || 1
  var pageSize = pagination.value.pageSize || 10
  ElMessageBox.confirm('确定要删除选中的数据吗', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    var ids = selectedRowKeys.value
      .map((o) => dataSource.value.find(x => x.key == (pageNum - 1) * pageSize + parseInt(o)).id)
      .join(',')
    deletePageData('/main/preCommPlan/batch/' + ids).then(() => {
      initTable(pagination.value, queryParam.value)
      state.selectedRowKeys = []
      state.loading = false
    })
  })
}

const customHeaderCell = (column: any) => {
  const redArray = [
    'financingVolume',
    'historySign',
    'ownFunds',
    'age',
    'tradingTenure',
    'operationalPreferences',
    'isTip',
    'weakness',
    'preferredCallTime',
    'excellentStaff',
    'corporation',
    'teachers',
    'customLike',
    'hasTwiceYx'
  ]
  const backArray = [
    'custName',
    'level',
    'exploitAccount',
    'corpName',
    'resourceTime',
    'createTime',
    'updateTime',
    'methodsTime',
    'empName',
    'deptName',
    'operation'
  ]
  if (redArray.indexOf(column.dataIndex) != -1) {
    return { style: { color: '#ff0000' } }
  }
  if (backArray.indexOf(column.dataIndex) != -1) {
    return {
      style: { fontWeight: 'bold' }
    }
  }
  if (column.title == '浅营销') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(251,228,213)' }
    }
  }
  if (column.title == '转营销') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(247,202,172)' }
    }
  }
  if (column.title == '营销') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(244,177,131)' }
    }
  }
  if (column.title == '经理工作') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(255,255,0)' }
    }
  }
  return {}
}

const handleImportError = (res: any) => {
  console.log(res)
}

const handleDownloadImport = () => {
  const fileName = '沟通计划表.xlsx'
  downloadData(
    '/main/preCommPlan/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const handleExport = () => {
  let queryInfo = store.state.system.queryInfo
  getPageListData(
    '/main/preCommPlan/download',
    {
      ...queryInfo
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    }) //处理文档流
    const down = document.createElement('a')
    down.download =
      '投教沟通计划表' +
      ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '') +
      '.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const previewUpdateDialog = ref(false)
const userList = ref([])
const previewUpdate = () => {
  getUserList()
  previewUpdateDialog.value = true
}

const getUserList = () => {
  getListData('/main/preCommPlan/getUserList', {}).then((res) => {
    userList.value = res
  })
}

const exportUserList = () => {
  let customHeader = ['姓名', '未更新客户数']
  let header = ['key', 'value']
  // 文件名
  let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
  const excel = new Excel()
  excel.exportExcel({
    name: '今日未更新名单-' + filename,
    title: '今日未更新名单-' + filename,
    data: userList.value,
    header,
    customHeader
  })
}

const initTable = (params: STablePaginationConfig = {}, query?: any) => {
  getPageListData('/main/preCommPlan/queryByCondition', {
    ...query,
    pageNo: pagination.value.current,
    pageSize: pagination.value.pageSize,
    ...order.value,
  }).then((res) => {
    dataSource.value = res.list
    totalSize.value = res.total
    count = dataSource.value.length
    pagination.value = {
      ...params,
      total: totalSize.value
    }
  })
}
onMounted(() => {
  initTable(pagination.value, queryParam.value)
  loadAccounts()
})

watch(
  () => ({ ...pagination.value }),
  (cur, pre) => {
    if (cur.current !== pre.current || cur.pageSize !== pre.pageSize) {
      initTable(pagination.value, queryParam.value)
    }
  }
)

const phoneRegex: any = ref(/(\+86|0086)?\s*\b1[3456789]\d{9}\b/);

const checkPhoneNumber = (inputText: string) => {
  if (inputText.trim() === '') {
    // 如果输入为空，根据需求决定是否允许空值
    return true; // 假设允许空值
  }

  const matches = inputText.match(phoneRegex.value);

  if (matches && matches.length > 0) {
    return false;
  } else {
    return true;
  }
};

function getValueSetter() {
  return ({ record, column, row, newValue, oldValue }: any) => {
    let stack = new Error().stack
    if (stack.indexOf('handleKeyDown') != -1) {
      return true
    }
    let field = column.dataIndex
    let body = {}
    body[field] = newValue
    body['id'] = record.id

    const paramStr = JSON.stringify(body)
    // 判断是否包含手机号信息，如果有提示不能保存
    if (!checkPhoneNumber(paramStr)) {
      ElMessage.error('不能保存，请检查是否有手机号信息！')
      return;
    }

    editPageData(editUrl, body).then(() => {
      initTable(pagination.value, queryParam.value)
    })
    return true
  }
}
const columns = [
  {
    title: '客户名字',
    dataIndex: 'custName',
    type: 'input',
    autoHeight: true,
    editable: true,
    width: 110,
    align: 'center',
    resizable: true,
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '重要程度',
    dataIndex: 'level',
    type: 'level',
    editable: 'cellEditorSlot',
    width: 80,
    align: 'center',
    resizable: true,
    fixed: 'left',
    valueSetter: getValueSetter(),
    sorter: {
    },
  },
  {
    title: '开发账号/ID',
    dataIndex: 'exploitAccount',
    type: 'input',
    autoHeight: true,
    editable: true,
    width: 120,
    resizable: true,
    align: 'center',
    fixed: 'left',
    valueSetter: getValueSetter(),
    sorter: {
    }
  },
  {
    title: '企业微信主体',
    dataIndex: 'corpName',
    type: 'corpName',
    editable: 'cellEditorSlot',
    width: 140,
    align: 'center',
    resizable: true,
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '资源时间',
    dataIndex: 'resourceTime',
    type: 'date',
    width: 110,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    fixed: 'left',
    editable: 'cellEditorSlot',
    sorter: {
    }
  },
  {
    title: '填报人',
    dataIndex: 'empName',
    type: 'input',
    width: 80,
    align: 'center',
    resizable: true,
    autoHeight: true,
    fixed: 'left'
  },
  {
    title: '最新经理建议时间',
    dataIndex: 'methodsTime',
    type: 'input',
    width: 180,
    align: 'center',
    resizable: true,
    autoHeight: true,
    fixed: 'left',
    sorter: {
    }
  },
  {
    title: '资金量',
    dataIndex: 'financingVolume',
    width: 100,
    type: 'input',
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    fixed: 'left',
    editable: true,
    sorter: {
    }
  },
  {
    title: '浅营销',
    align: 'center',
    children: [
      {
        title: '签约经历+具体签约哪家',
        dataIndex: 'historySign',
        type: 'input',
        autoHeight: true,
        editable: true,
        width: 100,
        align: 'center',
        resizable: true,
        valueSetter: getValueSetter()
      },
      {
        title: '自有资金',
        dataIndex: 'ownFunds',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '年龄（超60要了解身体状况）',
        dataIndex: 'age',
        width: 100,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true,
        sorter: {
        }
      },
      {
        title: '炒股年限',
        dataIndex: 'tradingTenure',
        width: 100,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '操作喜好（短/中/长）',
        dataIndex: 'operationalPreferences',
        width: 100,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '温馨提示+票池使用方法',
        dataIndex: 'isTip',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '客户操作痛点',
        dataIndex: 'weakness',
        type: 'textarea',
        width: 200,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        autoHeight: true,
        editable: 'cellEditorSlot'
      },
      {
        title: '方便接听电话的时间',
        dataIndex: 'preferredCallTime',
        width: 100,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '优秀员工',
        dataIndex: 'excellentStaff',
        type: 'select',
        width: 70,
        resizable: true,
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '公司',
        dataIndex: 'corporation',
        type: 'select',
        width: 70,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '老师',
        dataIndex: 'teachers',
        type: 'select',
        width: 70,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '软件',
        dataIndex: 'software',
        type: 'select',
        width: 70,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '选股',
        dataIndex: 'stockPick',
        type: 'select',
        width: 70,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '有2次听课记录',
        dataIndex: 'hasTwice',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '客户对绩效/软件/课程/老师点赞',
        dataIndex: 'customLike',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '2通1分钟以上的有效电话沟通',
        dataIndex: 'twoEffectivePhone',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      }
    ]
  },
  {
    title: '转营销',
    align: 'center',
    children: [
      {
        title: '介绍服务',
        dataIndex: 'introductionService',
        type: 'select',
        width: 70,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '报价时间和金额',
        dataIndex: 'quoteTimeAndAmount',
        type: 'input',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '客户对绩效/软件/课程/老师点赞',
        dataIndex: 'customLikeZyx',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      }
    ]
  },
  {
    title: '营销',
    align: 'center',
    children: [
      {
        title: '有2次听课记录',
        dataIndex: 'hasTwiceYx',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '抗拒点',
        dataIndex: 'resistPoint',
        type: 'textarea',
        width: 200,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        autoHeight: true,
        editable: 'cellEditorSlot'
      }
    ]
  },
  {
    title: '经理工作',
    align: 'center',
    children: [
      // {
      //   title: '经理给到的今日跟踪方案',
      //   dataIndex: 'followupSuggestion',
      //   type: 'textarea',
      //   width: 200,
      //   resizable: true,
      //   align: 'center',
      //   valueSetter: getValueSetter(),
      //   autoHeight: true
      // },
      {
        title: '客户可接受的报价价格',
        dataIndex: 'acceptedAmount',
        type: 'input',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '客户开发阶段' + '（浅营销/转营销/营销/逼单）',
        dataIndex: 'exploitPhase',
        type: 'exploitPhase',
        width: 120,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      }
    ]
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    type: 'input',
    width: 180,
    align: 'center',
    autoHeight: true,
    sorter: {
    }
  },
  {
    title: '修改时间',
    dataIndex: 'updateTime',
    type: 'input',
    width: 180,
    align: 'center',
    autoHeight: true,
    sorter: {
    }
  },
  {
    title: '最新经理建议时间',
    dataIndex: 'methodsTime',
    type: 'input',
    width: 180,
    align: 'center',
    autoHeight: true,
    sorter: {
    },
  },
  {
    title: '是否成交',
    dataIndex: 'isEnd',
    type: 'select',
    width: 100,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot',
    fixed: 'right'
  },
  {
    title: '操作',
    width: 200,
    resizable: true,
    key: 'operation',
    align: 'center',
    dataIndex: 'operation',
    fixed: 'right'
  }
]
const editableData: UnwrapRef<Record<string, DataItem>> = reactive({})


// 2024-12-2 变更
const activeNames = ref(['1', '浅营销', '转营销', '营销', '经理工作', '3', '4', '5'])
const router = useRouter()
const modalDialog = ref(false)
const modalTitle = ref('')
const currentDataRow: any = ref({})
const handleFillClick = () => {
  modalTitle.value = '新增'
  currentDataRow.value = {}
  modalDialog.value = true
  planIdR.value = ''
  workerRecords.value = []
}

const handleEdit = (item: any) => {
  view.value = false
  modalTitle.value = '编辑'
  currentDataRow.value = { ...item }
  modalDialog.value = true
  planIdR.value = item.id
  planRecord.value = item
  planIdAI.value = item.id
  getManagerMethods(item)
  getWorkerRecords(item.id)
  getAiSuggestions(item.id)
  showTextareaAI.value = false
  showTextareaM.value = false
  showTextareaR.value = false
  generateLoading.value = false
}
const view = ref(false)
const handleView = (item: any) => {
  view.value = true
  modalTitle.value = '查看'
  currentDataRow.value = { ...item }
  modalDialog.value = true
  planIdR.value = item.id
  planRecord.value = item
  planIdAI.value = item.id
  getManagerMethods(item)
  getWorkerRecords(item.id)
  getAiSuggestions(item.id)
  showTextareaAI.value = false
  showTextareaM.value = false
  showTextareaR.value = false
}

const ref_m = ref(null)
const saveData = () => {
  if (showTextareaM.value) {
    ref_m?.value.focus()
    ElMessage.warning('请先点击保存按钮，保存跟踪建议')
    return;
  }
  if (showTextareaR.value) {
    r_c?.value.focus()
    ElMessage.warning('请先点击保存按钮，保存跟踪记录')
    return;
  }
  if (showTextareaAI.value) {
    aiTxt.value.focus()
    ElMessage.warning('请先点击保存按钮，保存AI建议')
    return;
  }

  if (!currentDataRow.value.qyUserId) {
    ElMessage.error('请先点击按钮选择并绑定企微客户')
    return;
  }

  editPageData(editUrl, currentDataRow.value).then(() => {
    modalDialog.value = false
    initTable(pagination.value, queryParam.value)
  })
}

// 取消保存逻辑后的提交按钮
const newSaveData = async () => {
  if (showTextareaM.value) {
    let body = {
      followupSuggestion: txtMethod.value,
      recordId: mtdId.value,
      id: planRecord.value.id
    }
    await editPageData('/main/preCommPlan/managerMethods/save', body).then(() => {
      getManagerMethods(planRecord.value)
      showTextareaM.value = false
      txtMethod.value = ''
    })
  }
  if (showTextareaR.value) {
    let body = {
      followupCondition: txtRecord.value,
      txtRecordC: txtRecordC.value,
      txtRecordP: txtRecordP.value,
      recordId: rtdId.value,
      id: planIdR.value
    }
    if (!txtRecordC.value) {
      r_c.value.focus()
      ElMessage.warning("请输入今日客户表现")
      return;
    }
    if (!txtRecord.value) {
      r_r.value.focus()
      ElMessage.warning("请输入今日跟踪情况")
      return;
    }
    if (!txtRecordP.value) {
      r_p.value.focus()
      ElMessage.warning("请输入明日跟踪计划")
      return;
    }
    await editPageData('/main/preCommPlan/workerRecords/save', body).then(() => {
      getWorkerRecords(planIdR.value)
      showTextareaR.value = false
    })

  }
  if (showTextareaAI.value) {
    let body = {
      content: txtAI.value,
      id: aiSuggestionId.value,
      planId: planIdAI.value,
      planTime: planTime.value
    }
    await editPageData('/main/preCommPlan/aiSuggestions/save', body).then(() => {
      getAiSuggestions(planIdAI.value)
      showTextareaAI.value = false
    })
  }

  if (!currentDataRow.value.qyUserId) {
    ElMessage.error('请先点击按钮选择并绑定企微客户')
    return;
  }

  editPageData(editUrl, currentDataRow.value).then(() => {
    modalDialog.value = false
    initTable(pagination.value, queryParam.value)
  })

}



const cancel = () => {
  modalDialog.value = false
  showTextareaR.value = false
}

/************************  绑定客户  ************************/
const qyUserDialog = ref(false)
const openUserSelect = () => {
  if (currentDataRow.value.exploitAccount && currentDataRow.value.corpName) {
    qyUserDialog.value = true
    searchQyUser()
  } else {
    ElMessage.warning('请先选择主体、填写开发账号')
  }
}

const uname = ref('')
const qyUserList = ref([])
const searchQyUser = () => {
  qyUserList.value = []
  getListData(
    '/main/preCommPlan/queryQyUsers',
    {
      uname: uname.value,
      sid: currentDataRow.value.exploitAccount,
      corpName: currentDataRow.value.corpName
    }
  ).then((res: any) => {
    qyUserList.value = res
    if (qyUserList.value.length == 0) {
      ElMessage.warning('无匹配用户,请检查确认开发账号是否正确')
    }
  })
}

const selectQyUser = (item: any) => {
  if (currentDataRow.value.custName) {
    ElMessageBox.confirm(`请选择绑定方式`, '提示', {
      confirmButtonText: '绑定客户编号并更新客户姓名',
      cancelButtonText: '仅绑定客户编号',
      type: 'error',
      center: true
    }).then(() => {
      currentDataRow.value.custName = item.uname
      currentDataRow.value.qyUserId = item.uid
      qyUserDialog.value = false
    }).catch(() => {
      currentDataRow.value.qyUserId = item.uid
      qyUserDialog.value = false
    })
  } else {
    currentDataRow.value.custName = item.uname
    currentDataRow.value.qyUserId = item.uid
    qyUserDialog.value = false
  }
}

const customCell = (obj: any) => {
  const selected = levels.value.find((o: any) => o.value == obj.record.level)
  if (selected) {
    return {
      style: {
        backgroundColor: selected.color
      }
    }
  } else {
    return {
      style: {
        backgroundColor: 'transparent'
      }
    }
  }

}


const accounts = ref([])
const querySearch = (queryString: string, cb: any) => {
  const results = queryString
    ? accounts.value.filter(createFilter(queryString))
    : accounts.value
  // call callback function to return suggestions
  cb(results)
}
const createFilter = (queryString: string) => {
  return (account: any) => {
    return (
      account.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    )
  }
}

const loadAccounts = () => {
  const corpId = corpObj.value ? corpObj.value[currentDataRow.value.corpName] : ''
  getListData(
    '/main/preCommPlan/queryUsedBy',
    {
      usedBy: userInfo.realName,
      corpId: corpId
    }
  ).then((res: any) => {
    accounts.value = res.map((item: any) => { return { value: item.userId, corpId: item.corpId } })
  })
}

const handleSelect = (item: any) => {
  currentDataRow.value.corpName = corpObj.value[item.corpId];
}

const handleTransForm = () => {
  acceptUserDialog.value = true
}

const saveAcceptUser = () => {
  if (acceptUserId.value) {
    if (selectedRowKeys.value.length > 0) {
      var pageNum = pagination.value.current || 1
      var pageSize = pagination.value.pageSize || 10
      ElMessageBox.confirm('确定要转移选中的数据至账号使用人吗', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error',
        center: true
      }).then(() => {
        var ids = selectedRowKeys.value
          .map((o) => dataSource.value[(pageNum - 1) * pageSize + parseInt(o)].id)
          .join(',')
        editPageData('/main/preCommPlan/transForm', {
          acceptUserId: acceptUserId.value,
          ids: ids
        }).then(() => {
          ElMessage.success('转移成功')
          acceptUserDialog.value = false
          initTable(pagination.value, queryParam.value)
        })
      })
    } else {
      ElMessage.warning('请选择要转移的数据')
    }
  } else {
    ElMessage.warning('请选择要转移数据的承接人')
  }
}

const cancelAcceptUser = () => {
  acceptUserDialog.value = false
  acceptUserId.value = ''
}

const acceptUserDialog = ref(false)
const acceptUserId = ref('')


return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_copy_outlined = _resolveComponent("copy-outlined")!
  const _component_s_table = _resolveComponent("s-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      ref: preSalSearchRef.value,
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: handleResetClick,
      onSearchBtnClick: handleSearchClick
    }, null, 8, ["searchFormConfig"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "default",
          size: "medium",
          loading: state.loading,
          onClick: start
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消全选")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createElementVNode("span", _hoisted_4, [
          (hasSelected.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(`已选中 ${selectedRowKeys.value.length} 行`), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_unref(canView))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "medium",
              onClick: handleFillClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(userInfo).isManager == '1')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              size: "medium",
              onClick: handleTransForm
            }, {
              default: _withCtx(() => [
                _createTextVNode("数据转移")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(canView))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              size: "medium",
              onClick: handleBatchDelete
            }, {
              default: _withCtx(() => [
                _createTextVNode("批量删除")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(canView))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              type: "primary",
              size: "medium",
              onClick: handleDownloadImport
            }, {
              default: _withCtx(() => [
                _createTextVNode("模板下载")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(canView))
          ? (_openBlock(), _createBlock(_unref(ElUpload), {
              key: 4,
              style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
              action: importAction,
              headers: headers.value,
              accept: ".xls,.xlsx",
              "on-success": handleImportSuccess,
              "on-error": handleImportError,
              "show-file-list": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "medium",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("数据导入")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["headers"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleExport
        }, {
          default: _withCtx(() => [
            _createTextVNode("数据导出")
          ]),
          _: 1
        }),
        (_unref(userInfo).isManager == '1')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 5,
              type: "primary",
              size: "medium",
              onClick: previewUpdate
            }, {
              default: _withCtx(() => [
                _createTextVNode("今日未更新名单")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_s_table, {
      bordered: "",
      "data-source": dataSource.value,
      columns: columns,
      stripe: "",
      pagination: pagination.value,
      "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((pagination).value = $event)),
      sticky: "",
      scroll: { x: 2000 },
      "show-header-scrollbar": "",
      "auto-header-height": "",
      "row-selection": {
        selectedRowKeys: selectedRowKeys.value,
        onChange: onSelectChange
      },
      onChange: onSortChange,
      "custom-header-cell": customHeaderCell,
      "custom-cell": customCell
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(canView))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (handleView(record))
                  }, "查看", 8, _hoisted_7))
                : _createCommentVNode("", true),
              (!_unref(canView))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: ($event: any) => (handleEdit(record))
                  }, "编辑", 8, _hoisted_8))
                : _createCommentVNode("", true),
              (dataSource.value.length && !_unref(canView))
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 2,
                    title: "确定要删除吗?",
                    onConfirm: ($event: any) => (onDelete(record.id, record.key))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      cellEditor: _withCtx(({ column, modelValue, save, closeEditor, editorRef }) => [
        (column.type === 'date')
          ? (_openBlock(), _createBlock(_component_a_date_picker, {
              key: 0,
              locale: _unref(locale),
              ref: editorRef,
              bordered: false,
              value: _unref(dayjs)(
            modelValue.value
              ? modelValue.value
              : _unref(dayjs)(`${new Date()}`).format('YYYY-MM-DD')
          )
            ,
              style: {"width":"100%"},
              open: "",
              "allow-clear": false,
              "onUpdate:value": 
              (v) => {
                modelValue.value = v?.format('YYYY-MM-DD') ?? ''
                save()
              }
            ,
              onBlur: closeEditor,
              onKeydown: _withKeys(closeEditor, ["esc"]),
              onClick: _withModifiers(closeEditor, ["stop"])
            }, null, 8, ["locale", "value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
          : (column.type === 'select')
            ? (_openBlock(), _createBlock(_component_a_select, {
                key: 1,
                ref: editorRef,
                bordered: true,
                value: modelValue.value,
                style: {"width":"120px"},
                options: [
            {
              value: '√',
              label: '√'
            },
            {
              value: '×',
              label: '×'
            }
          ],
                open: "",
                "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                onBlur: closeEditor,
                onKeydown: _withKeys(closeEditor, ["esc"]),
                onClick: _withModifiers(closeEditor, ["stop"])
              }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
            : (column.type === 'exploitPhase')
              ? (_openBlock(), _createBlock(_component_a_select, {
                  key: 2,
                  ref: editorRef,
                  bordered: true,
                  value: modelValue.value,
                  style: {"width":"120px"},
                  options: [
            {
              value: '浅营销',
              label: '浅营销'
            },
            {
              value: '转营销',
              label: '转营销'
            },
            {
              value: '营销',
              label: '营销'
            },
            {
              value: '逼单',
              label: '逼单'
            }
          ],
                  open: "",
                  "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                  onBlur: closeEditor,
                  onKeydown: _withKeys(closeEditor, ["esc"]),
                  onClick: _withModifiers(closeEditor, ["stop"])
                }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
              : (column.type === 'corpName')
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 3,
                    ref: editorRef,
                    bordered: true,
                    value: modelValue.value,
                    style: {"width":"240px"},
                    options: corpNames.value,
                    open: "",
                    "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                    onBlur: closeEditor,
                    onKeydown: _withKeys(closeEditor, ["esc"]),
                    onClick: _withModifiers(closeEditor, ["stop"])
                  }, null, 8, ["value", "options", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
                : (column.type === 'level')
                  ? (_openBlock(), _createBlock(_component_a_select, {
                      key: 4,
                      ref: editorRef,
                      bordered: true,
                      value: modelValue.value,
                      style: {"width":"240px"},
                      options: levels.value,
                      open: "",
                      "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                      onBlur: closeEditor,
                      onKeydown: _withKeys(closeEditor, ["esc"]),
                      onClick: _withModifiers(closeEditor, ["stop"])
                    }, null, 8, ["value", "options", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
                  : (column.type == 'textarea')
                    ? (_openBlock(), _createBlock(_component_a_textarea, {
                        key: 5,
                        ref: editorRef,
                        bordered: true,
                        value: modelValue.value,
                        autosize: "true",
                        "onUpdate:value": 
            (v) => {
              modelValue.value = v
            }
          ,
                        onBlur: save,
                        onKeydown: _withKeys(closeEditor, ["esc"])
                      }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown"]))
                    : _createCommentVNode("", true)
      ]),
      contextmenuPopup: _withCtx((args) => [
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", {
            class: _normalizeClass(["popup-item", args.column.key === 'operation' && 'disabled']),
            onClick: ($event: any) => (handleAdd(args))
          }, [
            _createVNode(_component_copy_outlined),
            _createTextVNode(" 添加一行 ")
          ], 10, _hoisted_11),
          _createElementVNode("li", {
            class: _normalizeClass(["popup-item", args.column.key === 'operation' && 'disabled']),
            onClick: ($event: any) => (onDelete(args.record.id, args.record.key, args))
          }, [
            _createVNode(_component_copy_outlined),
            _createTextVNode(" 删除 ")
          ], 10, _hoisted_12)
        ])
      ]),
      _: 1
    }, 8, ["data-source", "pagination", "row-selection"]),
    _createVNode(_component_el_dialog, {
      modelValue: methodDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((methodDialog).value = $event)),
      title: "跟踪方案",
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_timeline_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  (!showTextareaM.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        style: {"height":"36px","margin-right":"15px"},
                        type: "primary",
                        size: "medium",
                        onClick: addMethod
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showTextareaM.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        style: {"height":"36px","margin-right":"15px"},
                        type: "primary",
                        size: "medium",
                        onClick: saveMethod
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("保存")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showTextareaM.value)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 2,
                        type: "textarea",
                        rows: 2,
                        placeholder: "请输入内容",
                        modelValue: txtMethod.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((txtMethod).value = $event))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_input, {
                    type: "hidden",
                    modelValue: _ctx.planId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.planId) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerMethods.value, (mtd, index) => {
              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                timestamp: mtd.createdTime,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        (isCreatedToday(mtd.createdTime, mtd.createdBy))
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "danger",
                              size: "small",
                              style: {"position":"absolute","right":"0","top":"0"},
                              onClick: ($event: any) => (deleteMethod(mtd.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("删除")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("h4", null, _toDisplayString(mtd.content), 1),
                        _createElementVNode("p", null, _toDisplayString(mtd.empName), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["timestamp"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: recordDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((recordDialog).value = $event)),
      title: "跟踪记录",
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_timeline_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  (!showTextareaR.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        style: {"height":"36px","margin-right":"15px"},
                        type: "primary",
                        size: "medium",
                        onClick: addRecord
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showTextareaR.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        style: {"height":"36px","margin-right":"15px"},
                        type: "primary",
                        size: "medium",
                        onClick: saveRecord
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("保存")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showTextareaR.value)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 2,
                        type: "textarea",
                        rows: 2,
                        placeholder: "请输入内容",
                        modelValue: txtRecord.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((txtRecord).value = $event))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_input, {
                    type: "hidden",
                    modelValue: _ctx.planId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.planId) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workerRecords.value, (mtd, index) => {
              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                timestamp: mtd.createdTime,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    (isCreatedToday(mtd.createdTime, mtd.createdBy))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "danger",
                          size: "small",
                          style: {"position":"absolute","right":"0","top":"0"},
                          onClick: ($event: any) => (deleteRecord(mtd.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("h4", null, _toDisplayString(mtd.content), 1),
                    _createElementVNode("p", null, _toDisplayString(mtd.empName), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["timestamp"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "30%",
      modelValue: previewUpdateDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((previewUpdateDialog).value = $event)),
      title: "今日未更新名单"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_button, {
            style: {"position":"absolute","right":"0","top":"0"},
            type: "primary",
            size: "medium",
            onClick: exportUserList
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (user, index) => {
            return (_openBlock(), _createBlock(_component_el_card, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", null, "姓名：" + _toDisplayString(user.name), 1),
                  _createElementVNode("div", null, "未更新客户数量：" + _toDisplayString(user.notUpdated), 1),
                  _createElementVNode("div", null, "总数量：" + _toDisplayString(user.total), 1)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "80%",
      modelValue: modalDialog.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((modalDialog).value = $event)),
      title: modalTitle.value,
      top: "2vh",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      onClose: stopAi
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "dialog-parent" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, {
              modelValue: activeNames.value,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((activeNames).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, {
                  title: "基本信息",
                  name: "1",
                  disabled: ""
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      (currentDataRow.value.qyUserId)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(currentDataRow.value.qyUserId), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      inline: true,
                      class: "demo-form-inline",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.filter(item => !item.children && item.editable && item.dataIndex != 'custName' && item.dataIndex != 'corpName'), (item) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (item.type === 'input')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (item.dataIndex == 'exploitAccount')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_el_form_item, {
                                          class: "blue-background",
                                          label: "企业微信主体"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: currentDataRow.value.corpName,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentDataRow.value.corpName) = $event)),
                                              placeholder: "请选择",
                                              onChange: loadAccounts,
                                              clearable: "",
                                              filterable: "",
                                              disabled: view.value
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(corpNames.value, (corp, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: index,
                                                    label: corp.label,
                                                    value: corp.value
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, {
                                          class: "blue-background",
                                          label: item.title
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_autocomplete, {
                                              "fetch-suggestions": querySearch,
                                              onSelect: handleSelect,
                                              modelValue: currentDataRow.value[item.dataIndex],
                                              "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                              clearable: "",
                                              placeholder: "请输入",
                                              readonly: view.value
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]),
                                        _createVNode(_component_el_form_item, {
                                          class: "blue-background",
                                          label: "客户名字"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: currentDataRow.value.custName,
                                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentDataRow.value.custName) = $event)),
                                              clearable: "",
                                              placeholder: "请输入",
                                              readonly: view.value
                                            }, null, 8, ["modelValue", "readonly"]),
                                            (!view.value)
                                              ? (_openBlock(), _createBlock(_component_el_button, {
                                                  key: 0,
                                                  type: "primary",
                                                  plain: "",
                                                  size: "small",
                                                  onClick: _withModifiers(openUserSelect, ["stop","prevent"]),
                                                  style: {"height":"30px"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("绑定客户")
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ], 64))
                                    : (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 1,
                                        class: "blue-background",
                                        label: item.title
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            modelValue: currentDataRow.value[item.dataIndex],
                                            "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                            clearable: "",
                                            placeholder: "请输入",
                                            readonly: view.value
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                ], 64))
                              : (item.type === 'select')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 1,
                                    class: "blue-background",
                                    label: item.title
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: currentDataRow.value[item.dataIndex],
                                        "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                        placeholder: "请选择",
                                        clearable: "",
                                        disabled: view.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "√",
                                            value: "√"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "×",
                                            value: "×"
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                : (item.type === 'date')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 2,
                                      class: "blue-background",
                                      label: item.title
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          disabled: view.value,
                                          modelValue: currentDataRow.value[item.dataIndex],
                                          "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                          type: "date",
                                          placeholder: "选择日期",
                                          clearable: ""
                                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  : (item.type === 'corpName')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 3,
                                        class: "blue-background",
                                        label: item.title
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: currentDataRow.value[item.dataIndex],
                                            "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                            placeholder: "请选择",
                                            clearable: "",
                                            filterable: "",
                                            disabled: view.value
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(corpNames.value, (corp, index) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: index,
                                                  label: corp.label,
                                                  value: corp.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.filter(item => item.children), (item) => {
                  return (_openBlock(), _createBlock(_component_el_collapse_item, {
                    title: item.title,
                    name: item.title,
                    class: "flex100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        class: "demo-form-inline",
                        "label-width": "220px"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (child.type === 'input')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    class: "blue-background",
                                    label: child.title
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: currentDataRow.value[child.dataIndex],
                                        "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                        clearable: "",
                                        placeholder: "请输入",
                                        readonly: view.value
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                : (child.type === 'select')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      class: "blue-background",
                                      label: child.title
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: currentDataRow.value[child.dataIndex],
                                          "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                          placeholder: "请选择",
                                          clearable: "",
                                          disabled: view.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              label: "√",
                                              value: "√"
                                            }),
                                            _createVNode(_component_el_option, {
                                              label: "×",
                                              value: "×"
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  : (child.type === 'date')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 2,
                                        class: "blue-background",
                                        label: child.title
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_date_picker, {
                                            modelValue: currentDataRow.value[child.dataIndex],
                                            "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                            disabled: view.value,
                                            type: "date",
                                            placeholder: "选择日期",
                                            clearable: ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    : (child.type === 'corpName')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 3,
                                          class: "blue-background",
                                          label: child.title
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: currentDataRow.value[child.dataIndex],
                                              "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                              placeholder: "请选择",
                                              clearable: "",
                                              filterable: "",
                                              disabled: view.value
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(corpNames.value, (corp, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: index,
                                                    label: corp.label,
                                                    value: corp.value
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]))
                                      : (child.type === 'exploitPhase')
                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 4,
                                            class: "blue-background",
                                            label: child.title
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_select, {
                                                modelValue: currentDataRow.value[child.dataIndex],
                                                "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                                placeholder: "请选择",
                                                clearable: "",
                                                disabled: view.value
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exploitPhase, (col, index) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: index,
                                                      label: col.label,
                                                      value: col.value
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["title", "name"]))
                }), 256)),
                _createVNode(_component_el_collapse_item, {
                  title: "经理建议",
                  name: "3"
                }, {
                  default: _withCtx(() => [
                    (planRecord.value.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (managerMethods.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerMethods.value, (mtd, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    style: {"text-align":"left"}
                                  }, [
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("div", _hoisted_25, _toDisplayString(mtd.createdTime + " " + mtd.empName + " " + mtd.content), 1),
                                      (isCreatedToday(mtd.createdTime, mtd.createdBy) && !view.value)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            onClick: ($event: any) => (editMethod(mtd)),
                                            style: {"cursor":"pointer","margin-left":"20px"}
                                          }, " 编辑 ", 8, _hoisted_26))
                                        : _createCommentVNode("", true),
                                      (isCreatedToday(mtd.createdTime, mtd.createdBy) && !view.value)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            onClick: ($event: any) => (deleteMethod(mtd.id)),
                                            style: {"cursor":"pointer","margin-left":"20px"}
                                          }, " 删除 ", 8, _hoisted_27))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_28, [
                            (!showTextareaM.value && !view.value && _unref(userInfo).isManager == '1')
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  style: {"height":"36px","margin-right":"15px","margin-bottom":"10px","float":"right"},
                                  type: "primary",
                                  size: "medium",
                                  onClick: addMethod
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("新增")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (showTextareaM.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  style: {"height":"36px","margin-right":"15px","margin-bottom":"10px","float":"right"},
                                  type: "error",
                                  size: "medium",
                                  onClick: cancelMethods
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("取消")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (showTextareaM.value)
                              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                  key: 2,
                                  style: {"height":"36px","margin-right":"15px","margin-bottom":"10px","float":"right"},
                                  type: "primary",
                                  size: "medium",
                                  onClick: saveMethod
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("保存")
                                  ]),
                                  _: 1
                                }, 512)), [
                                  [_vShow, false]
                                ])
                              : _createCommentVNode("", true),
                            (showTextareaM.value)
                              ? (_openBlock(), _createBlock(_component_el_input, {
                                  key: 3,
                                  ref_key: "ref_m",
                                  ref: ref_m,
                                  type: "textarea",
                                  rows: 2,
                                  placeholder: "请输入内容",
                                  modelValue: txtMethod.value,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((txtMethod).value = $event))
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_input, {
                              type: "hidden",
                              modelValue: planRecord.value.id,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((planRecord.value.id) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_collapse_item, {
                  title: "AI建议",
                  name: "4"
                }, {
                  default: _withCtx(() => [
                    (planIdAI.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          (aiSuggestions.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiSuggestions.value, (ais, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    style: {"text-align":"left"}
                                  }, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, [
                                        (isCreatedToday(ais.createdTime, ais.createdBy) && !view.value)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              onClick: ($event: any) => (editAiSuggestion(ais)),
                                              style: {"cursor":"pointer","margin-right":"20px"}
                                            }, " 编辑 ", 8, _hoisted_33))
                                          : _createCommentVNode("", true),
                                        (isCreatedToday(ais.createdTime, ais.createdBy) && !view.value)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              onClick: ($event: any) => (deleteSuggestion(ais.id)),
                                              style: {"cursor":"pointer","margin-right":"20px"}
                                            }, " 删除 ", 8, _hoisted_34))
                                          : _createCommentVNode("", true),
                                        (ais.canScore && ais.percentage == '-1' && !view.value)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 2,
                                              onClick: ($event: any) => (aiScore(ais)),
                                              style: {"cursor":"pointer"}
                                            }, " 手工评分 ", 8, _hoisted_35))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("pre", null, _toDisplayString(ais.createdTime + " " + ais.empName + " ------------------------------------------"), 1)
                                      ]),
                                      (ais.planTime)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                            _createElementVNode("pre", _hoisted_38, _toDisplayString('计划沟通日期: ' + ais.planTime + '\r\n'), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _hoisted_39,
                                      _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("pre", _hoisted_41, _toDisplayString(ais.content), 1)
                                      ]),
                                      (ais.percentage == '-1')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
                                        : _createCommentVNode("", true),
                                      (ais.percentage != '-1' && ais.percentage != '' && ais.percentage != null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                                        : _createCommentVNode("", true),
                                      (ais.chatRecords)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                            _createElementVNode("pre", _hoisted_49, _toDisplayString(ais.chatRecords), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (ais.percentage)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
                                        : _createCommentVNode("", true),
                                      (ais.percentage)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                            _createElementVNode("pre", _hoisted_54, _toDisplayString(ais.percentage), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_55, [
                            (!showTextareaAI.value && !alreadyHas.value && !view.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  style: {"height":"36px","margin-right":"15px","margin-bottom":"10px","float":"right"},
                                  type: "primary",
                                  size: "medium",
                                  onClick: addSuggestionAI
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("新增")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (showTextareaAI.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  style: {"height":"36px","margin-right":"15px","margin-bottom":"10px","float":"right"},
                                  type: "error",
                                  size: "medium",
                                  onClick: clearAndCancel
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("取消")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (showTextareaAI.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 2,
                                  style: {"height":"36px","margin-right":"15px","margin-bottom":"10px","float":"right"},
                                  type: "primary",
                                  size: "medium",
                                  loading: generateLoading.value,
                                  onClick: generateSuggestionAI
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("AI生成")
                                  ]),
                                  _: 1
                                }, 8, ["loading"]))
                              : _createCommentVNode("", true),
                            (showTextareaAI.value)
                              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                  key: 3,
                                  style: {"height":"36px","margin-right":"15px","float":"right"},
                                  type: "primary",
                                  size: "medium",
                                  disabled: generateLoading.value,
                                  onClick: saveSuggestionAI
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("保存")
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])), [
                                  [_vShow, false]
                                ])
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_form, null, {
                              default: _withCtx(() => [
                                (showTextareaAI.value)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      label: "计划沟通日期"
                                    }, {
                                      default: _withCtx(() => [
                                        (showTextareaAI.value)
                                          ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                              key: 0,
                                              modelValue: planTime.value,
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((planTime).value = $event)),
                                              style: {"float":"left"},
                                              type: "datetime",
                                              format: "YYYY-MM-DD HH:mm",
                                              "value-format": "YYYY-MM-DD HH:mm",
                                              placeholder: "请选择计划沟通日期"
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (showTextareaAI.value)
                                  ? (_openBlock(), _createBlock(_component_el_input, {
                                      key: 1,
                                      ref_key: "aiTxt",
                                      ref: aiTxt,
                                      type: "textarea",
                                      autofocus: "",
                                      rows: 10,
                                      readonly: generateLoading.value,
                                      placeholder: "请输入内容",
                                      modelValue: txtAI.value,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((txtAI).value = $event))
                                    }, null, 8, ["readonly", "modelValue"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_input, {
                                  type: "hidden",
                                  modelValue: planIdAI.value,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((planIdAI).value = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_collapse_item, {
                  title: "跟踪记录",
                  name: "5"
                }, {
                  default: _withCtx(() => [
                    (planIdR.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          (workerRecords.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workerRecords.value, (rtd, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    style: {"text-align":"left","padding":"10px"}
                                  }, [
                                    _createElementVNode("div", _hoisted_58, [
                                      _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("div", _hoisted_60, _toDisplayString(rtd.createdTime + " " + rtd.empName), 1),
                                        _createElementVNode("div", _hoisted_61, [
                                          _hoisted_62,
                                          _createTextVNode(_toDisplayString(rtd.contentC), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_63, [
                                          _hoisted_64,
                                          _createTextVNode(_toDisplayString(rtd.content), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_65, [
                                          _hoisted_66,
                                          _createTextVNode(_toDisplayString(rtd.contentP), 1)
                                        ])
                                      ]),
                                      (isCreatedToday(rtd.createdTime, rtd.createdBy) && !view.value)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            onClick: ($event: any) => (editRecord(rtd)),
                                            style: {"cursor":"pointer","margin-left":"20px"}
                                          }, " 编辑 ", 8, _hoisted_67))
                                        : _createCommentVNode("", true),
                                      (isCreatedToday(rtd.createdTime, rtd.createdBy) && !view.value)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            onClick: ($event: any) => (deleteRecord(rtd.id)),
                                            style: {"cursor":"pointer","margin-left":"20px"}
                                          }, " 删除 ", 8, _hoisted_68))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_69, [
                            (!showTextareaR.value && !view.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  style: {"height":"36px","margin-right":"15px","margin-bottom":"10px","float":"right"},
                                  type: "primary",
                                  size: "medium",
                                  onClick: addRecord
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("新增")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (showTextareaR.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  style: {"height":"36px","margin-right":"15px","margin-bottom":"10px","float":"right"},
                                  type: "error",
                                  size: "medium",
                                  onClick: cancelRecords
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("取消")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (showTextareaR.value)
                              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                  key: 2,
                                  style: {"height":"36px","margin-right":"15px","margin-bottom":"10px","float":"right"},
                                  ref: "ref_r",
                                  type: "primary",
                                  size: "medium",
                                  onClick: saveRecord
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("保存")
                                  ]),
                                  _: 1
                                }, 512)), [
                                  [_vShow, false]
                                ])
                              : _createCommentVNode("", true),
                            (showTextareaR.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                  _createElementVNode("div", _hoisted_71, [
                                    _hoisted_72,
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_el_input, {
                                        ref_key: "r_c",
                                        ref: r_c,
                                        type: "textarea",
                                        rows: 2,
                                        placeholder: "请输入内容",
                                        modelValue: txtRecordC.value,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((txtRecordC).value = $event))
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_73, [
                                    _hoisted_74,
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_el_input, {
                                        ref_key: "r_r",
                                        ref: r_r,
                                        type: "textarea",
                                        rows: 2,
                                        placeholder: "请输入内容",
                                        modelValue: txtRecord.value,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((txtRecord).value = $event))
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_75, [
                                    _hoisted_76,
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_el_input, {
                                        ref_key: "r_p",
                                        ref: r_p,
                                        type: "textarea",
                                        rows: 2,
                                        placeholder: "请输入内容",
                                        modelValue: txtRecordP.value,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((txtRecordP).value = $event))
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_input, {
                              type: "hidden",
                              modelValue: planIdR.value,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((planIdR).value = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (!view.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: newSaveData
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("提交")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: cancel }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      title: "可选客户",
      modelValue: qyUserDialog.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((qyUserDialog).value = $event)),
      width: "50%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _createVNode(_component_el_input, {
            modelValue: uname.value,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((uname).value = $event)),
            placeholder: "请输入客户昵称",
            style: {"width":"200px"}
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: searchQyUser
          }, {
            default: _withCtx(() => [
              _createTextVNode("搜索")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_79, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qyUserList.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_card, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: item.avatar,
                        alt: "",
                        style: {"width":"40px","height":"40px","border-radius":"50%","margin-right":"10px"}
                      }, null, 8, _hoisted_82)
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", null, _toDisplayString(item.uname + "(" + item.remark + ")"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: ($event: any) => (selectQyUser(item))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("选择")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "选择承接人",
      modelValue: acceptUserDialog.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((acceptUserDialog).value = $event)),
      width: "30%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_85, [
          _hoisted_86,
          _createElementVNode("div", null, [
            _createVNode(_component_el_select, {
              modelValue: acceptUserId.value,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((acceptUserId).value = $event)),
              clearable: "",
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acceptUserList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.realName,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_87, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: saveAcceptUser
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { onClick: cancelAcceptUser }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})